import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'
const AllUserReportsContext = createContext()


export const AllUserReportsProvider = ({ children }) => {
    const [ reportsUuid, setReportsUuid ] = useState([])

    useEffect(() => {
        axios.get(`/reports/getReports`)
        .then(res => res.json())
        .then(res => setReportsUuid(res))
        return () => {}
    },[])
   
    return (
        <AllUserReportsContext.Provider value={{
            reportsUuid
        }}>
            { children}
        </AllUserReportsContext.Provider>
    )

}

export function useAllUserReportsContext() {
    return useContext(AllUserReportsContext)
}